﻿﻿export type IconName = 'home' | 'template' | 'users' | 'settings' | 'logout' | 'microphone' | 'stop' | 'copy' | 'pdf' | 'bold' | 'italic' | 'underline' | 'strikethrough' | 'list' | 'orderedList' | 'quote' | 'horizontalLine' | 'alignLeft' | 'alignCenter' | 'alignRight' | 'alignJustify' | 'indent' | 'outdent' | 'chevronDown' | 'chevronUp' | 'chevron-left' | 'chevron-right' | 'x' | 'x-circle' | 'search' | 'alertCircle' | 'building' | 'at' | 'user-check' | 'user' | 'calendar' | 'clock' | 'inbox' | 'edit' | 'trash' | 'alert-triangle' | 'info' | 'check-circle' | 'microsoft' | 'google' | 'sun' | 'moon' | 'monitor' | 'mail' | 'key' | 'plus' | 'file-plus' | 'book-open' | 'pencil' | 'file-text' | 'user-circle' | 'user-pen' | 'play' | 'pause' | 'arrowRight' | 'arrowUp' | 'save' | 'palette' | 'folder' | 'plus-circle' | 'archive' | 'list-start' | 'list-tree' | 'cpu' | 'cloud' | 'cloud-upload' | 'cloud-check' | 'sparkles' | 'globe' | 'rotate-ccw' | 'check' | 'send' | 'stethoscope' | 'arrows-up-down' | 'arrows-right-left' | 'eye' | 'eye-off' | 'charts' | 'bar-chart-mid' | 'target' | 'wing' | 'help-circle' | 'share' | 'link' | 'user-plus' | 'shield' | 'layout' | 'layout-dashboard' | 'mic' | 'git-compare' | 'tag' | 'zap' | 'badge' | 'hash' | 'activity' | 'wand' | 'magic-sparkles' | 'patients-bed' | 'phone' | 'smartphone-qr' | 'map-pin' | 'briefcase' | 'patient-bandage' | 'layers' | 'body-lung' | 'body-thyroid' | 'body-prostate' | 'body-kidney' | 'body-hip' | 'body-hand' | 'body-shoulder' | 'plug' | 'terminal' | 'mars' | 'upload' | 'download' | 'file-history' | 'headphones' | 'file' | 'file-horizontal' | 'clipboard-check' | 'sliders';

interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
}

export function Icon({ name, size = 24, className = '' }: IconProps) {
  const iconPaths = {
    home: (
      <>
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </>
    ),
    template: (
      <>
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
      </>
    ),
    users: (
      <>
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </>
    ),
    settings: (
      <>
        <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
        <circle cx="12" cy="12" r="3" />
      </>
    ),
    logout: (
      <>
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <polyline points="16 17 21 12 16 7" />
        <line x1="21" y1="12" x2="9" y2="12" />
      </>
    ),
    microphone: (
      <>
        <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
        <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
        <line x1="12" y1="19" x2="12" y2="23" />
        <line x1="8" y1="23" x2="16" y2="23" />
      </>
    ),
    stop: (
      <rect x="6" y="6" width="12" height="12" rx="2" />
    ),
    copy: (
      <>
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
      </>
    ),
    pdf: (
      <>
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </>
    ),
    bold: (
      <>
        <path d="M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z" />
        <path d="M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z" />
      </>
    ),
    italic: (
      <>
        <line x1="19" y1="4" x2="10" y2="4" />
        <line x1="14" y1="20" x2="5" y2="20" />
        <line x1="15" y1="4" x2="9" y2="20" />
      </>
    ),
    underline: (
      <>
        <path d="M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3" />
        <line x1="4" y1="21" x2="20" y2="21" />
      </>
    ),
    strikethrough: (
      <>
        <path d="M16 4H9a3 3 0 0 0-2.83 4" />
        <path d="M14 12a4 4 0 0 1 0 8H6" />
        <line x1="4" y1="12" x2="20" y2="12" />
      </>
    ),
    list: (
      <>
        <line x1="8" y1="6" x2="21" y2="6" />
        <line x1="8" y1="12" x2="21" y2="12" />
        <line x1="8" y1="18" x2="21" y2="18" />
        <line x1="3" y1="6" x2="3.01" y2="6" />
        <line x1="3" y1="12" x2="3.01" y2="12" />
        <line x1="3" y1="18" x2="3.01" y2="18" />
      </>
    ),
    orderedList: (
      <>
        <line x1="10" y1="6" x2="21" y2="6" />
        <line x1="10" y1="12" x2="21" y2="12" />
        <line x1="10" y1="18" x2="21" y2="18" />
        <path d="M4 6h1v4" />
        <path d="M4 10h2" />
        <path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1" />
      </>
    ),
    quote: (
      <>
        <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" />
        <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z" />
      </>
    ),
    horizontalLine: (
      <line x1="3" y1="12" x2="21" y2="12" />
    ),
    alignLeft: (
      <>
        <line x1="17" y1="10" x2="3" y2="10" />
        <line x1="21" y1="6" x2="3" y2="6" />
        <line x1="21" y1="14" x2="3" y2="14" />
        <line x1="17" y1="18" x2="3" y2="18" />
      </>
    ),
    alignCenter: (
      <>
        <line x1="18" y1="10" x2="6" y2="10" />
        <line x1="21" y1="6" x2="3" y2="6" />
        <line x1="21" y1="14" x2="3" y2="14" />
        <line x1="18" y1="18" x2="6" y2="18" />
      </>
    ),
    alignRight: (
      <>
        <line x1="21" y1="10" x2="7" y2="10" />
        <line x1="21" y1="6" x2="3" y2="6" />
        <line x1="21" y1="14" x2="3" y2="14" />
        <line x1="21" y1="18" x2="7" y2="18" />
      </>
    ),
    alignJustify: (
      <>
        <line x1="21" y1="10" x2="3" y2="10" />
        <line x1="21" y1="6" x2="3" y2="6" />
        <line x1="21" y1="14" x2="3" y2="14" />
        <line x1="21" y1="18" x2="3" y2="18" />
      </>
    ),
    indent: (
      <>
        <polyline points="3 8 7 12 3 16" />
        <line x1="21" y1="12" x2="11" y2="12" />
        <line x1="21" y1="6" x2="11" y2="6" />
        <line x1="21" y1="18" x2="11" y2="18" />
      </>
    ),
    outdent: (
      <>
        <polyline points="7 8 3 12 7 16" />
        <line x1="21" y1="12" x2="11" y2="12" />
        <line x1="21" y1="6" x2="11" y2="6" />
        <line x1="21" y1="18" x2="11" y2="18" />
      </>
    ),
    chevronDown: (
      <polyline points="6 9 12 15 18 9" />
    ),
    chevronUp: (
      <polyline points="18 15 12 9 6 15" />
    ),
    'chevron-left': (
      <polyline points="15 18 9 12 15 6" />
    ),
    'chevron-right': (
      <polyline points="9 18 15 12 9 6" />
    ),
    x: (
      <>
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </>
    ),
    'x-circle': (
      <>
        <circle cx="12" cy="12" r="10" />
        <line x1="15" y1="9" x2="9" y2="15" />
        <line x1="9" y1="9" x2="15" y2="15" />
      </>
    ),
    search: (
      <>
        <circle cx="11" cy="11" r="8" />
        <path d="M21 21l-4.35-4.35" />
      </>
    ),
    alertCircle: (
      <>
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </>
    ),
    building: (
      <>
        <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
        <path d="M9 22v-4h6v4" />
        <path d="M8 6h.01" />
        <path d="M16 6h.01" />
        <path d="M12 6h.01" />
        <path d="M12 10h.01" />
        <path d="M12 14h.01" />
        <path d="M16 10h.01" />
        <path d="M16 14h.01" />
        <path d="M8 10h.01" />
        <path d="M8 14h.01" />
      </>
    ),
    at: (
      <>
        <circle cx="12" cy="12" r="4" />
        <path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94" />
      </>
    ),
    'user-check': (
      <>
        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="8.5" cy="7" r="4" />
        <polyline points="17 11 19 13 23 9" />
      </>
    ),
    user: (
      <>
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </>
    ),
    calendar: (
      <>
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </>
    ),
    clock: (
      <>
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </>
    ),
    inbox: (
      <>
        <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
        <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
      </>
    ),
    edit: (
      <>
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
      </>
    ),
    trash: (
      <>
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
        <line x1="10" y1="11" x2="10" y2="17" />
        <line x1="14" y1="11" x2="14" y2="17" />
      </>
    ),
    'alert-triangle': (
      <>
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </>
    ),
    info: (
      <>
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="16" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
      </>
    ),
    'check-circle': (
      <>
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
      </>
    ),
    microsoft: (
      <>
        <rect x="3" y="3" width="8" height="8" fill="#f25022" stroke="none" />
        <rect x="13" y="3" width="8" height="8" fill="#00a4ef" stroke="none" />
        <rect x="3" y="13" width="8" height="8" fill="#7fba00" stroke="none" />
        <rect x="13" y="13" width="8" height="8" fill="#ffb900" stroke="none" />
      </>
    ),
    google: (
      <>
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4" stroke="none" />
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" stroke="none" />
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" stroke="none" />
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" stroke="none" />
      </>
    ),
    sun: (
      <>
        <circle cx="12" cy="12" r="5" />
        <line x1="12" y1="1" x2="12" y2="3" />
        <line x1="12" y1="21" x2="12" y2="23" />
        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
        <line x1="1" y1="12" x2="3" y2="12" />
        <line x1="21" y1="12" x2="23" y2="12" />
        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
      </>
    ),
    moon: (
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    ),
    monitor: (
      <>
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
        <line x1="8" y1="21" x2="16" y2="21" />
        <line x1="12" y1="17" x2="12" y2="21" />
      </>
    ),
    mail: (
      <>
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </>
    ),
    key: (
      <>
        <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
      </>
    ),
    plus: (
      <>
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
      </>
    ),
    'file-plus': (
      <>
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="12" y1="18" x2="12" y2="12" />
        <line x1="9" y1="15" x2="15" y2="15" />
      </>
    ),
    'book-open': (
      <>
        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
        <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
      </>
    ),
    'pencil': (
      <>
        <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
      </>
    ),
    'file': (
      <>
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
      </>
    ),
    'file-horizontal': (
      <>
        <g transform="rotate(-90 12 12)">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
        </g>
      </>
    ),
    sliders: (
      <>
        <path d="M20 7h-9" />
        <path d="M14 17H5" />
        <circle cx="17" cy="17" r="3" />
        <circle cx="7" cy="7" r="3" />
      </>
    ),
    'clipboard-check': (
      <>
        <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
        <polyline points="9 14 11 16 15 12" />
      </>
    ),
    'file-text': (
      <>
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </>
    ),
    'file-history': (
      <>
        {/* Empty document with folded corner; bottom-right corner cut away so
            the history badge sits cleanly. Scaled up slightly so the sheet has
            more presence next to the history badge. */}
        <g transform="translate(-1.32 -1.44) scale(1.12)">
          <path d="M8 21H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8l4 4v3" />
          <polyline points="14 3 14 7 18 7" />
        </g>
        {/* History badge (counter-clockwise return arrow + clock) bottom-right */}
        <g transform="translate(8.5 8.5) scale(0.64)" strokeWidth="3.3">
          <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
          {/* Arrowhead: bolder, slightly longer prongs so the chevron is clear */}
          <path d="M3 2.5V8h5.5" strokeWidth="3.9" />
          <path d="M12 7v5l4 2" />
        </g>
      </>
    ),
    'user-circle': (
      <>
        <circle cx="12" cy="12" r="10" />
        <circle cx="12" cy="10" r="3" />
        <path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662" />
      </>
    ),
    'user-pen': (
      <>
        <path d="M11.5 15H7a4 4 0 0 0-4 4v2" />
        <path d="M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z" />
        <circle cx="10" cy="7" r="4" />
      </>
    ),
    'play': (
      <polygon points="5 3 19 12 5 21 5 3" />
    ),
    'pause': (
      <>
        <rect x="6" y="4" width="4" height="16" rx="1" />
        <rect x="14" y="4" width="4" height="16" rx="1" />
      </>
    ),
    'arrowRight': (
      <>
        <line x1="5" y1="12" x2="19" y2="12" />
        <polyline points="12 5 19 12 12 19" />
      </>
    ),
    'arrowUp': (
      <>
        <line x1="12" y1="19" x2="12" y2="5" />
        <polyline points="5 12 12 5 19 12" />
      </>
    ),
    'save': (
      <>
        <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
        <polyline points="17 21 17 13 7 13 7 21" />
        <polyline points="7 3 7 8 15 8" />
      </>
    ),
    'palette': (
      <>
        <circle cx="13.5" cy="6.5" r=".5" fill="currentColor" />
        <circle cx="17.5" cy="10.5" r=".5" fill="currentColor" />
        <circle cx="8.5" cy="7.5" r=".5" fill="currentColor" />
        <circle cx="6.5" cy="12.5" r=".5" fill="currentColor" />
        <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.555C21.965 6.012 17.461 2 12 2z" />
      </>
    ),
    folder: (
      <>
        <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
      </>
    ),
    'plus-circle': (
      <>
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="16" />
        <line x1="8" y1="12" x2="16" y2="12" />
      </>
    ),
    archive: (
      <>
        <polyline points="21 8 21 21 3 21 3 8" />
        <rect x="1" y="3" width="22" height="5" />
        <line x1="10" y1="12" x2="14" y2="12" />
      </>
    ),
    'list-start': (
      <>
        <path d="M16 12H3" />
        <path d="M16 6H3" />
        <path d="M10 18H3" />
        <path d="M21 6v10a2 2 0 0 1-2 2h-5" />
        <path d="m16 16-2 2 2 2" />
      </>
    ),
    'list-tree': (
      <>
        <path d="M21 12h-8" />
        <path d="M21 6H8" />
        <path d="M21 18h-8" />
        <path d="M3 6v4c0 1.1.9 2 2 2h3" />
        <path d="M3 10v6c0 1.1.9 2 2 2h3" />
      </>
    ),
    cpu: (
      <>
        <rect x="4" y="4" width="16" height="16" rx="2" ry="2" />
        <rect x="9" y="9" width="6" height="6" />
        <line x1="9" y1="1" x2="9" y2="4" />
        <line x1="15" y1="1" x2="15" y2="4" />
        <line x1="9" y1="20" x2="9" y2="23" />
        <line x1="15" y1="20" x2="15" y2="23" />
        <line x1="20" y1="9" x2="23" y2="9" />
        <line x1="20" y1="14" x2="23" y2="14" />
        <line x1="1" y1="9" x2="4" y2="9" />
        <line x1="1" y1="14" x2="4" y2="14" />
      </>
    ),
    cloud: (
      <>
        <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" />
      </>
    ),
    'cloud-upload': (
      <>
        <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
        <polyline points="16 16 12 12 8 16" />
        <line x1="12" y1="12" x2="12" y2="18" />
      </>
    ),
    upload: (
      <>
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="17 8 12 3 7 8" />
        <line x1="12" y1="3" x2="12" y2="15" />
      </>
    ),
    download: (
      <>
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="7 10 12 15 17 10" />
        <line x1="12" y1="15" x2="12" y2="3" />
      </>
    ),
    'cloud-check': (
      <>
        <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
        <polyline points="9 15 12 18 17 13" />
      </>
    ),
    sparkles: (
      <>
        <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
        <path d="M5 3v4" />
        <path d="M19 17v4" />
        <path d="M3 5h4" />
        <path d="M17 19h4" />
      </>
    ),
    globe: (
      <>
        <circle cx="12" cy="12" r="10" />
        <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
        <path d="M2 12h20" />
      </>
    ),
    'rotate-ccw': (
      <>
        <polyline points="1 4 1 10 7 10" />
        <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
      </>
    ),
    check: (
      <polyline points="20 6 9 17 4 12" />
    ),
    send: (
      <>
        <line x1="22" y1="2" x2="11" y2="13" />
        <polygon points="22 2 15 22 11 13 2 9 22 2" />
      </>
    ),
    headphones: (
      <>
        <path d="M3 14v-2a9 9 0 0 1 18 0v2" />
        <path d="M21 16a2 2 0 0 1-2 2h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h3z" />
        <path d="M3 16a2 2 0 0 0 2 2h1a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H3z" />
      </>
    ),
    stethoscope: (
      <>
        <path d="M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3" />
        <path d="M8 15v1a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v-4" />
        <circle cx="20" cy="10" r="2" />
      </>
    ),
    'arrows-up-down': (
      <>
        <path d="M7 15l-5 5-5-5" />
        <path d="M2 20V4" />
        <path d="M17 9l5-5 5 5" />
        <path d="M22 4v16" />
      </>
    ),
    'arrows-right-left': (
      <>
        <path d="M17 11H3" />
        <path d="m7 7-4 4 4 4" />
        <path d="M21 13H7" />
        <path d="m17 17 4-4-4-4" />
      </>
    ),
    eye: (
      <>
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
      </>
    ),
    'eye-off': (
      <>
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
        <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
        <line x1="1" y1="1" x2="23" y2="23" />
      </>
    ),
    charts: (
      <>
        <path d="M3 3v18h18" />
        <rect x="7" y="12" width="3" height="8" rx="1" />
        <rect x="12" y="8" width="3" height="12" rx="1" />
        <rect x="17" y="5" width="3" height="15" rx="1" />
      </>
    ),
    'bar-chart-mid': (
      <>
        <rect x="3" y="13" width="5" height="8" rx="1.2" fill="currentColor" stroke="none" />
        <rect x="9.5" y="3" width="5" height="18" rx="1.2" fill="currentColor" stroke="none" />
        <rect x="16" y="9" width="5" height="12" rx="1.2" fill="currentColor" stroke="none" />
      </>
    ),
    target: (
      <>
        <circle cx="12" cy="12" r="10" />
        <circle cx="12" cy="12" r="6" />
        <circle cx="12" cy="12" r="2" />
      </>
    ),
    wing: (
      <>
        <path d="M4 18c0-6 3-12 16-14-2 3-3 6-3 9 0 2-.5 3.5-2 5H4z" />
        <path d="M7 14c2-4 5-7 10-9" />
        <path d="M9 11c2-3 4.5-5 8-7" />
      </>
    ),
    'help-circle': (
      <>
        <circle cx="12" cy="12" r="10" />
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </>
    ),
    'share': (
      <>
        <circle cx="18" cy="5" r="3" />
        <circle cx="6" cy="12" r="3" />
        <circle cx="18" cy="19" r="3" />
        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
      </>
    ),
    'link': (
      <>
        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
      </>
    ),
    'user-plus': (
      <>
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <line x1="19" y1="8" x2="19" y2="14" />
        <line x1="22" y1="11" x2="16" y2="11" />
      </>
    ),
    'shield': (
      <>
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </>
    ),
    'layout': (
      <>
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
        <line x1="3" y1="9" x2="21" y2="9" />
        <line x1="9" y1="21" x2="9" y2="9" />
      </>
    ),
    'layout-dashboard': (
      <>
        <rect x="3" y="3" width="7" height="9" rx="1.5" />
        <rect x="14" y="3" width="7" height="5" rx="1.5" />
        <rect x="14" y="12" width="7" height="9" rx="1.5" />
        <rect x="3" y="16" width="7" height="5" rx="1.5" />
      </>
    ),
    'mic': (
      <>
        <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
        <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
        <line x1="12" y1="19" x2="12" y2="23" />
        <line x1="8" y1="23" x2="16" y2="23" />
      </>
    ),
    'git-compare': (
      <>
        <circle cx="18" cy="18" r="3" />
        <circle cx="6" cy="6" r="3" />
        <path d="M13 6h3a2 2 0 0 1 2 2v7" />
        <path d="M11 18H8a2 2 0 0 1-2-2V9" />
      </>
    ),
    'tag': (
      <>
        <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
        <line x1="7" y1="7" x2="7.01" y2="7" />
      </>
    ),
    'zap': (
      <>
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
      </>
    ),
    'badge': (
      <>
        <rect x="2" y="4" width="20" height="16" rx="2" ry="2" />
        <circle cx="9" cy="10" r="2" />
        <path d="M15 8h2" />
        <path d="M15 12h2" />
        <path d="M7 16h10" />
      </>
    ),
    'hash': (
      <>
        <line x1="4" y1="9" x2="20" y2="9" />
        <line x1="4" y1="15" x2="20" y2="15" />
        <line x1="10" y1="3" x2="8" y2="21" />
        <line x1="16" y1="3" x2="14" y2="21" />
      </>
    ),
    'activity': (
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    ),
    'wand': (
      <>
        <path d="M4.5 16.5 3 22l5.5-1.5L21.1 7.9a2.1 2.1 0 0 0 0-3L19.1 3a2.1 2.1 0 0 0-3 0Z" />
        <path d="m14 7 3 3" />
      </>
    ),
    'magic-sparkles': (
      <>
        <path d="M12 2l1.09 3.26L16 6l-2.91.74L12 10l-1.09-3.26L8 6l2.91-.74L12 2z" fill="currentColor" stroke="none" />
        <path d="M18 8l.72 2.16L21 11l-2.28.84L18 14l-.72-2.16L15 11l2.28-.84L18 8z" fill="currentColor" stroke="none" />
        <path d="M6 14l.72 2.16L9 17l-2.28.84L6 20l-.72-2.16L3 17l2.28-.84L6 14z" fill="currentColor" stroke="none" />
      </>
    ),
    'patients-bed': (
      <>
        <circle cx="12" cy="7" r="4" />
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <line x1="20" y1="2.5" x2="20" y2="6.5" />
        <line x1="18" y1="4.5" x2="22" y2="4.5" />
      </>
    ),
    'phone': (
      <>
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
      </>
    ),
    // Filled silhouette. The phone's left edge is cut away between y=5.6 and
    // y=18.4 so the QR sits in the gap without touching the border.
    'smartphone-qr': (
      <g transform="translate(-2.21 -1.8) scale(1.15)">
        <path
          fill="currentColor"
          stroke="none"
          fillRule="evenodd"
          d="M10.8 1.8H19.6A2.2 2.2 0 0 1 21.8 4V20A2.2 2.2 0 0 1 19.6 22.2H10.8A2.2 2.2 0 0 1 8.6 20V18.4H10.1V5.6H8.6V4A2.2 2.2 0 0 1 10.8 1.8ZM10.9 3.7H19.5A0.8 0.8 0 0 1 20.3 4.5V18.7A0.8 0.8 0 0 1 19.5 19.5H10.9A0.8 0.8 0 0 1 10.1 18.7V4.5A0.8 0.8 0 0 1 10.9 3.7ZM14.35 20.3H16.05A0.45 0.45 0 0 1 16.05 21.2H14.35A0.45 0.45 0 0 1 14.35 20.3Z"
        />
        <g strokeWidth="1.36">
          <path d="M3.6 10.3V8.4A0.7 0.7 0 0 1 4.3 7.7H6.2" />
          <path d="M9.6 7.7H11.5A0.7 0.7 0 0 1 12.2 8.4V10.3" />
          <path d="M12.2 13.7V15.6A0.7 0.7 0 0 1 11.5 16.3H9.6" />
          <path d="M6.2 16.3H4.3A0.7 0.7 0 0 1 3.6 15.6V13.7" />
        </g>
        <g strokeWidth="0.73">
          <rect x="5.55" y="9.7" width="1.6" height="1.6" rx="0.22" />
          <rect x="8.55" y="9.7" width="1.6" height="1.6" rx="0.22" />
          <rect x="5.55" y="12.7" width="1.6" height="1.6" rx="0.22" />
          <rect x="8.55" y="12.7" width="1.6" height="1.6" rx="0.28" fill="currentColor" />
        </g>
      </g>
    ),
    'map-pin': (
      <>
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </>
    ),
    'briefcase': (
      <>
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      </>
    ),
    'patient-bandage': (
      <>
        <circle cx="12" cy="7" r="4" />
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <path d="M8.2 5.8 Q12 3.8 15.8 5.8" />
        <path d="M8.2 7 Q12 5 15.8 7" />
        <line x1="11.2" y1="4.6" x2="10.2" y2="3" />
        <line x1="12.8" y1="4.6" x2="13.8" y2="3" />
      </>
    ),
    layers: (
      <>
        <polygon points="12 2 2 7 12 12 22 7 12 2" />
        <polyline points="2 17 12 22 22 17" />
        <polyline points="2 12 12 17 22 12" />
      </>
    ),
    'body-lung': (
      <>
        <path d="M12 4v6" />
        <path d="M9 10c-3 0-5 2-6 5s-1 5 1 5h5c1 0 2-1 2-2v-4" />
        <path d="M15 10c3 0 5 2 6 5s1 5-1 5h-5c-1 0-2-1-2-2v-4" />
        <circle cx="12" cy="3" r="1" />
      </>
    ),
    'body-thyroid': (
      <>
        <path d="M12 3v4" />
        <path d="M8 9c0-2 1.8-3 4-3s4 1 4 3" />
        <ellipse cx="8.5" cy="13" rx="3" ry="4.5" />
        <ellipse cx="15.5" cy="13" rx="3" ry="4.5" />
        <path d="M11.5 10v7" />
        <path d="M12.5 10v7" />
      </>
    ),
    'body-prostate': (
      <>
        <ellipse cx="12" cy="14" rx="6" ry="4" />
        <path d="M12 10v-5" />
        <path d="M10 5h4" />
        <line x1="12" y1="18" x2="12" y2="21" />
        <path d="M8.5 12.5c1.5 0 2.5 1 3.5 1s2-1 3.5-1" />
      </>
    ),
    'body-kidney': (
      <>
        <path d="M8 4c-3 0-5 3-5 7 0 3 1 5 3 7s4 2 6 2" />
        <path d="M12 20c0-3-1-5-1-8s1-5 1-8" />
        <path d="M16 4c3 0 5 3 5 7 0 3-1 5-3 7s-4 2-6 2" />
        <path d="M9 10c1.5 1 4 1 6 0" />
      </>
    ),
    'body-hip': (
      <>
        <circle cx="12" cy="9" r="3" />
        <path d="M6 4c-1 3-2 7-1 11l2 5" />
        <path d="M18 4c1 3 2 7 1 11l-2 5" />
        <path d="M9 9c-2 0-4 1-5 2" />
        <path d="M15 9c2 0 4 1 5 2" />
        <line x1="12" y1="12" x2="12" y2="20" />
      </>
    ),
    'body-hand': (
      <>
        <path d="M8 13V5.5a1 1 0 0 1 2 0V12" />
        <path d="M10 10.5V4a1 1 0 0 1 2 0v8" />
        <path d="M12 10V3.5a1 1 0 0 1 2 0V12" />
        <path d="M14 11V5.5a1 1 0 0 1 2 0v7" />
        <path d="M16 12.5c0-1.5 1-2 1-4a1 1 0 0 0-2 0" />
        <path d="M8 13c-1.5 0-3 1-3 3.5S7 21 10 21h4c3 0 5-2 5-4.5S17 13 16 12.5" />
      </>
    ),
    'body-shoulder': (
      <>
        <circle cx="12" cy="8" r="3" />
        <path d="M5 18c0-4 3-7 7-7s7 3 7 7" />
        <path d="M4 14c-1 1-2 2.5-2 4" />
        <path d="M20 14c1 1 2 2.5 2 4" />
        <line x1="2" y1="18" x2="6" y2="18" />
        <line x1="18" y1="18" x2="22" y2="18" />
      </>
    ),
    'plug': (
      <>
        <path d="M12 22v-5" />
        <path d="M9 8V2" />
        <path d="M15 8V2" />
        <path d="M18 8v4a6 6 0 0 1-12 0V8z" />
      </>
    ),
    'terminal': (
      <>
        <polyline points="4 17 10 11 4 5" />
        <line x1="12" y1="19" x2="20" y2="19" />
      </>
    ),
    'mars': (
      <>
        <circle cx="10" cy="14" r="5" />
        <line x1="13.5" y1="10.5" x2="19" y2="5" />
        <polyline points="15 5 19 5 19 9" />
      </>
    ),

  };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      data-icon={name}
    >
      {iconPaths[name]}
    </svg>
  );
}